import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL || '/_/backend'}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent duplicate processing under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      const hash = window.location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        navigate('/login');
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const res = await fetch(`${API}/auth/google/session`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ session_id: sessionId })
        });

        if (res.ok) {
          const user = await res.json();
          // Clear the hash from URL
          window.history.replaceState(null, '', window.location.pathname);
          // Navigate to dashboard with user data
          navigate('/dashboard', { state: { user }, replace: true });
        } else {
          console.error('Google auth failed');
          navigate('/login');
        }
      } catch (e) {
        console.error('Auth callback error:', e);
        navigate('/login');
      }
    };

    processAuth();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-50">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-emerald-600 mx-auto mb-4" />
        <p className="text-stone-600 font-medium">Signing you in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
